import { SHELL } from "../shell/shell.const";

// PERFIL
const PROFILE = 'perfil';
const PROFILE_EDIT_USER = 'usuario';
const PROFILE_EDIT_ADDRESS = 'direccion';
const PROFILE_EDIT_DOCUMENT = 'documento';
const PROFILE_CHANGE_PASS = 'cambiar-contrasena';
const PROFILE_MY_ACCOUNT = 'mi-cuenta'
const PROFILE_WITHDRAWS = 'retiro';
const PROFILE_WITHDRAWS_CONFIRM = 'confirmacion';
const PROFILE_COMPLETE = 'perfil-usuario';
const PROFILE_REQUEST_EDITION = 'solicitar-edicion';
const PROFILE_CONFIG = 'configuracion';

const PROFILE_REG = 'registro';
const PROFILE_REG_STANDAR = 'estandar';
const PROFILE_REG_INFO = 'info';

const HISTORICAL = 'historico';

export const PROFILE_ROUTES = {
  PROFILE,
  PROFILE_EDIT_USER,
  PROFILE_EDIT_ADDRESS,
  PROFILE_EDIT_DOCUMENT,
  PROFILE_CHANGE_PASS,
  PROFILE_MY_ACCOUNT,
  PROFILE_WITHDRAWS,
  PROFILE_WITHDRAWS_CONFIRM,
  PROFILE_COMPLETE,
  PROFILE_REQUEST_EDITION,
  PROFILE_CONFIG,
  PROFILE_REG,
  PROFILE_REG_STANDAR,
  PROFILE_REG_INFO,

  /** `/s/perfil` */
  ROUTE_PROFILE: `/${SHELL}/${PROFILE}`,
  /** `/s/perfil/registro` */
  ROUTE_PROFILE_REG: `/${SHELL}/${PROFILE}/${PROFILE_REG}`,
  /** `/s/perfil/registro/estandar` */
  ROUTE_PROFILE_REG_STANDAR: `/${SHELL}/${PROFILE}/${PROFILE_REG}/${PROFILE_REG_STANDAR}`,
  /** `/s/perfil/registro/info` */
  ROUTE_PROFILE_REG_INFO: `/${SHELL}/${PROFILE}/${PROFILE_REG}/${PROFILE_REG_INFO}`,
  /** `/s/perfil/usuario` */
  ROUTE_PROFILE_EDIT_USER: `/${SHELL}/${PROFILE}/${PROFILE_EDIT_USER}`,
  /** `/s/perfil/direccion` */
  ROUTE_PROFILE_EDIT_ADDRESS: `/${SHELL}/${PROFILE}/${PROFILE_EDIT_ADDRESS}`,
  /** `/s/perfil/documento` */
  ROUTE_PROFILE_EDIT_DOCUMENT: `/${SHELL}/${PROFILE}/${PROFILE_EDIT_DOCUMENT}`,
  /** `/s/perfil/cambiar-contrasena` */
  ROUTE_PROFILE_CHANGE_PASS: `/${SHELL}/${PROFILE}/${PROFILE_CHANGE_PASS}`,
  /** `/s/perfil/mi-cuenta` */
  ROUTE_PROFILE_MY_ACCOUNT: `/${SHELL}/${PROFILE}/${PROFILE_MY_ACCOUNT}`,
  /** `/s/perfil/retiro` */
  ROUTE_PROFILE_WITHDRAWS: `/${SHELL}/${PROFILE}/${PROFILE_WITHDRAWS}`,
  /** `/s/perfil/retiro/confirmacion` */
  ROUTE_PROFILE_WITHDRAWS_CONFIRM: `/${SHELL}/${PROFILE}/${PROFILE_WITHDRAWS}/${PROFILE_WITHDRAWS_CONFIRM}`,
  /** `/s/perfil/perfil-usuario` */
  ROUTE_PROFILE_COMPLETE: `/${SHELL}/${PROFILE}/${PROFILE_COMPLETE}`,
  /** `/s/perfil/solicitar-edicion` */
  ROUTE_PROFILE_REQUEST_EDITION: `/${SHELL}/${PROFILE}/${PROFILE_REQUEST_EDITION}`,
  /** `/s/perfil/historico` */
  ROUTE_HISTORICAL: `/${SHELL}/${PROFILE}/${HISTORICAL}`,
  /** `/s/perfil/PROFILE_CONFIG` */
  ROUTE_PROFILE_CONFIG: `/${SHELL}/${PROFILE}/${PROFILE_CONFIG}`,
}
